const SectionForCities = Class(
	/**
	 * @lends {SectionForCities#}
	 */
	{
		__NAME: 'SectionForCities',

		background: null,
		bodyClass: 'small-nav',
		menuItem: 'for-cities',

		draw: function(){
			let heroUrl = {
				tag: 'a',
				href: D.url(D.Lang.get('for-cities.welcome.button.link')),
				className: 'button button-large button-pink',
				text: D.Lang.get('for-cities.welcome.button')
			};
			if (D.Lang.get('for-cities.welcome.button.link') === 'contact-us') {
				delete heroUrl.href;
				heroUrl.onclick = function() {
					D.scrollIntoView(document.querySelector('.corporate-form-wrapper'));
				};
			}

			new T.Hero({
				backgroundClass: `background-picture-for-cities`,
				backgroundOverlay: true,
				backgroundArrow: true,
				backgroundMask: 'white',
				title: D.Lang.get('for-cities.welcome.title'),
				text: D.Lang.get('for-cities.welcome.text'),
				button: mkE(heroUrl)
			}).append(this.layout.ct());

			mkE({
				tag: 'div',
				className: 'case-studies-wrapper',
				els: [
					this._caseStudies = new T.CaseStudies('city', this.apiCall)
				]
			}).append(this.layout.ct());

			this._testimonials = T.Quotes.get('local');
			if (this._testimonials) {
				mkE({
					tag: 'div',
					className: 'testimonials-wrapper',
					els: [
						this._testimonials
					]
				}).append(this.layout.ct());
			}

			mkE({
				tag: 'div',
				className: 'game-setup-wrapper',
				els: [
					{
						tag: 'div',
						className: 'container',
						els: [
							{
								tag: 'h2',
								text: D.Lang.get('for-cities.game-setup.title')
							}
						]
					},
					this._gameSetup = new T.GameSetup('for-cities', 'setup')
				]
			}).append(this.layout.ct());

			mkE({
				tag: 'div',
				className: 'easy-access-wrapper',
				els: [
					new T.EasyAccess()
				]
			}).append(this.layout.ct());

			mkE({
				tag: 'div',
				className: 'how-to-wrapper',
				els: [
					this._howTo = new T.HowTo([
						'matchmaker',
						'g-spot',
						'explorer',
						'sprinter',
						'hunter',
						'groupie',
						'expert',
						'detective',
						'coder'
					], 'matchmaker')
				]
			}).append(this.layout.ct());

			mkE({
				tag: 'div',
				className: 'corporate-form-wrapper',
				els: [
					new T.CorporateContactUs()
				]
			}).append(this.layout.ct());

			this.apiCall.call();
		},

		onShow() {
			if (this._caseStudies) {
				this._caseStudies.onShow();
			}
			if (this._testimonials) {
				this._testimonials.onShow();
			}
			if (this._gameSetup) {
				this._gameSetup.onShow();
			}
			if (this._howTo) {
				this._howTo.onShow();
			}
		},

		onLeave() {
			if (this._caseStudies) {
				this._caseStudies.onLeave();
			}
			if (this._testimonials) {
				this._testimonials.onLeave();
			}
			if (this._gameSetup) {
				this._gameSetup.onLeave();
			}
			if (this._howTo) {
				this._howTo.onLeave();
			}
		}
	},
	Section
);